import * as React from 'react';
import { css } from 'aphrodite';

import styles from './bulletedItemStyles';

export interface BulletedItemBase {
  title: string;
  time?: string;
  description?: string;
}

interface BulletedItemProps extends BulletedItemBase {
  index: number;
}

export default class BulletedItem extends React.Component<BulletedItemProps> {
  render() {
    const { title, description, time, index } = this.props;
    const isFirstChild = !index;
    return (
      <div
        className={css(
          styles.stepWrapper,
          isFirstChild && styles.stepWrapperFirstChild,
          styles.stepWrapperPaddingLeft,
          styles.stepWrapperPaddingBottom,
        )}
      >
        <div>
          <div className={css(styles.titleWrapper)}>
            <h3 className={css(styles.title, !isFirstChild && styles.notFirstTitle)}>{title}</h3>
            {time && <p className={css(styles.time, !isFirstChild && styles.notFirstTime)}>{time}</p>}
          </div>
          {description && <p className={css(styles.description)}>{description}</p>}
        </div>
      </div>
    );
  }
}
